/* eslint-disable react/jsx-no-target-blank, jsx-a11y/anchor-is-valid, jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
import { BrowserOption, BrowserOptionContainer, BrowserOptionText, UnsupportedBrowserBody, UnsupportedBrowserContact, UnsupportedBrowserContinueLink, UnsupportedBrowserHeader, UnsupportedBrowserTextWrapper, UnsupportedBrowserWrapper, } from './UnsupportedBrowserPrompt.styles';
import React from 'react';
import { useGlobalization } from '../../contexts/GlobalizationProvider';
export const supportedBrowsers = [
    {
        name: 'Chrome',
        image: '/browser-icons/chrome.png',
        url: 'https://google.com/chrome',
    },
];
export const UnsupportedBrowserPrompt = (props) => {
    const { t } = useGlobalization();
    return (React.createElement(UnsupportedBrowserWrapper, null,
        React.createElement(UnsupportedBrowserTextWrapper, null,
            React.createElement(UnsupportedBrowserHeader, null, t('Info360 has detected an unsupported browser.')),
            React.createElement(UnsupportedBrowserBody, null, t('Info360 is optimized for Chrome. We recommend that you download the Chrome browser and open Info360 there.'))),
        React.createElement(BrowserOptionContainer, null, supportedBrowsers.map((sb, index) => (React.createElement(BrowserOption, { key: index },
            React.createElement("a", { href: sb.url, target: "_blank" },
                React.createElement("img", { src: sb.image, alt: sb.name }),
                React.createElement(BrowserOptionText, null, sb.name)))))),
        React.createElement(UnsupportedBrowserContinueLink, { onClick: props.onUserAcceptsUnsupported }, "Continue anyway >"),
        React.createElement(UnsupportedBrowserContact, null,
            "For more assistance, please contact us via\u00A0",
            ' ',
            React.createElement("a", { href: "https://www.autodesk.com/support/contact-support", target: "_blank" }, t('the Autodesk support channels')),
            ".")));
};
export default UnsupportedBrowserPrompt;
